import { useParams } from 'react-router-dom';

import { Splash } from '../../../../../../shared/Components';
import { ColoringGridForm } from '../../components/ColoringGridForm';

import useColoringGrid from './hooks/useColoringGrid';

interface EditColoringGridParamTypes {
  id: string;
}

const EditColoringGrid = () => {
  const { id } = useParams<EditColoringGridParamTypes>();
  const { coloringGrid, isLoading } = useColoringGrid({ coloringGridId: id });

  if (isLoading || !coloringGrid) {
    return <Splash />;
  }

  return (
    <ColoringGridForm
      isPublished={!!coloringGrid.publishedAt}
      initialFormData={{
        ...coloringGrid,
        publisher: {
          label: '',
          value: coloringGrid.publisher,
        },
        premiumTier: {
          label: '',
          value: coloringGrid.premiumTier,
        },
        keywords: coloringGrid.keywords.join(' '),
        image: coloringGrid.url,
        imageResolution: coloringGrid?._meta?.originalResolution || '',
        status: {
          label: coloringGrid.status,
          value: coloringGrid.status,
        },
      }}
    />
  );
};

export default EditColoringGrid;
